import { render, staticRenderFns } from "./k3l-kplh-status.vue?vue&type=template&id=88546b4a&scoped=true&"
import script from "./k3l-kplh-status.vue?vue&type=script&lang=js&"
export * from "./k3l-kplh-status.vue?vue&type=script&lang=js&"
import style0 from "./k3l-kplh-status.vue?vue&type=style&index=0&id=88546b4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88546b4a",
  null
  
)

export default component.exports